if (!customElements.get('insta-feed')) {
  class logo_marquee extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init = () => {;
      $('.insta-feed-wrapper .swiper, .offer_slider.swiper').slick({
        rows: 2,
        infinite: true,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,
        arrows: false,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              centerMode: true
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: true
            }
          }
        ]
      })
    }
  }
  customElements.define('insta-feed', logo_marquee);
}